import { useState, useEffect} from 'react'
import { toast } from 'react-hot-toast'
import { ButtonFilledAutoWidth } from '../../components/button'
import { TextAreaInput1, TextInput } from '../../components/input'
import GoBack from '../../components/back/GoBack'
import SettingsMenu from '../staticscreens/SettingsMenu'
import { CreateSubscriptionService, GetSubscriptionService, UpdateSubscriptionService } from '../../services/admin/SubscriptionServices'
import { CreateCityListService, GetCityListService, UpdateCityListService } from '../../services/admin/CityListServices'

function CityList() {
 
  const [data,setdata] = useState({datas:'',});  
  const [error,seterror] = useState({datas:'',}); 
  
   useEffect(()=>{
      getdata()
    },[])
  
    async function getdata() {
      const response = await GetCityListService()
      if(response?.data?.datas?.length > 0){
          setdata(response?.data?.datas[0])
      }
    }

  function handlechange(e){
    setdata({...data,[e.target.name] : e.target.value})
    seterror({...error,[e.target.name]:''})
  }
  

  async function resetform(){
    setdata({datas:'',})
    seterror({datas:'',})
  }

  console.log("data",data)
  async function submitdata() {
     if(!data.datas){
        seterror({...error,datas:'This field is required to make changes*'})
    }else{
    if(data?._id === undefined || data?._id === null){
        const response = await CreateCityListService(data)
        if (response.status === 201) {
          resetform()
          getdata()
          toast.success('City List Created Successfully')
        } 
    }else{
       const response = await UpdateCityListService(data,data?._id)
        if (response.status === 200) {
          resetform()
          getdata()
          toast.success('City List Update Successfully')
        } 
    }
    }
  }

  return (
    <div className='md:flex '>


    <SettingsMenu />
 
  <div className='sm:w-full lg:w-72 px-4 pt-5' >


      <GoBack /> 
      
      

        <h6 className='font-bold'>City List</h6>
        <h6 className='text-[10px] bg-slate-100 p-2 font-[500] leading-snug' >Use the below form to create / update <b>City List</b>.</h6>
     

        <TextAreaInput1 
            mandatory={true}
            label={'City List'}  
            variant="datas"
            name="datas"
            type="text"
            error={error.datas}
            value={data.datas}
            handlechange={handlechange}
            placeholder=""
            InputLabelProps={{
                style: { color: '#fff', }, 
            }}/>

          
          <div className='my-5'>
           <ButtonFilledAutoWidth btnName="Save"  onClick={submitdata} />  
          </div>



    </div>
    </div>
  )
}

export default CityList